import {connect} from "react-redux";
import { useTranslation } from "react-i18next";

import { logout } from '../api';
import {createPin} from "../redux/pin/pinSlice";


const Logout = ({ dispatch, router, onClose }) => {
  const { t } = useTranslation();

  const onLogout = () => {
    logout().then(() => {
      dispatch(createPin(""));
      window.location.href = router.buildPath("login");
    })
  }

  return (
      <div>
        <div className="c-container_bg active">
          <div className="c-popup_div">
            <div className="c-popup_header">
              <p>{ t("Logging out") }</p>
            </div>
            <div className="c-popup_content">
              <p>{ t("You are going to be logged out, proceed?") }</p>
            </div>
            <br/>

            <button className="c-cancel_button" onClick={onClose} style={{marginRight: "20px"}}>
              { t("Cancel") }
            </button>
            <button className="c-valid_button" onClick={onLogout}>
              { t("Yes, log me out") }
            </button>

          </div>
        </div>
      </div>
  )
}

export default connect()(Logout);
